import styled from "styled-components";

export default styled.h3`
  padding: ${(props) => (props.padding ? props.padding : "2rem 0")};
  font-size: 2rem;
  color: #39b1e6;
  font-family: "Antique Olive", sans-serif;
  font-weight: 600;
`;
